import { render, staticRenderFns } from "./tooth-id-selector.vue?vue&type=template&id=5c46e146&"
import script from "./tooth-id-selector.vue?vue&type=script&lang=js&"
export * from "./tooth-id-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports